import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const CommunicatingStyleNew: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.8827 11.3364C20.6357 14.7443 21.5885 18.0247 23.7051 20.1412C25.1753 21.6114 27.207 22.5201 29.4529 22.5201H32.4081V26.861C32.4081 27.1862 32.7903 27.3608 33.0361 27.148L40.4313 20.7469L40.8303 20.4071C40.8598 20.3775 40.8968 20.348 40.9263 20.3184C42.5073 18.8408 43.4899 16.7279 43.4899 14.3933C43.4899 12.1473 42.5812 10.1157 41.111 8.6455C39.6408 7.1753 37.6091 6.2666 35.3632 6.2666H29.4065C26.1002 6.2668 23.0188 8.2315 21.8827 11.3364Z"
      fill="#3D3C38"
    />
    <path
      d="M27.2368 18.0875H36.8411C37.2491 18.0875 37.5799 17.7567 37.5799 17.3487C37.5799 16.9407 37.2491 16.6099 36.8411 16.6099H27.2368C26.6848 16.6099 26.3278 17.1932 26.5789 17.6848C26.7052 17.932 26.9593 18.0875 27.2368 18.0875Z"
      fill="#FF612B"
    />
    <path
      d="M27.2368 15.1324H36.8411C37.2491 15.1324 37.5799 14.8016 37.5799 14.3936C37.5799 13.9856 37.2491 13.6548 36.8411 13.6548H27.2368C26.6848 13.6548 26.3278 14.2381 26.5789 14.7297C26.7052 14.9768 26.9593 15.1324 27.2368 15.1324Z"
      fill="#FF612B"
    />
    <path
      d="M27.2368 12.1773H36.8411C37.2491 12.1773 37.5799 11.8465 37.5799 11.4385C37.5799 11.0305 37.2491 10.6997 36.8411 10.6997H27.2368C26.6848 10.6997 26.3278 11.283 26.5789 11.7746C26.7052 12.0218 26.9593 12.1773 27.2368 12.1773Z"
      fill="#FF612B"
    />
    <path
      d="M20.3879 18.0752H13.6692C11.136 18.0752 8.84443 19.1001 7.18613 20.7584C5.52783 22.4167 4.50293 24.7082 4.50293 27.2415C4.50293 29.8747 5.61123 32.2579 7.39443 33.9245C7.42783 33.9579 7.46943 33.9912 7.50273 34.0245L7.95273 34.4078L16.294 41.6277C16.5713 41.8677 17.0023 41.6707 17.0023 41.304V36.4077H20.3355C22.8687 36.4077 25.1603 35.3827 26.8186 33.7244C29.2059 31.3371 30.2806 27.6371 28.8741 23.7932C27.5927 20.2913 24.1172 18.0752 20.3879 18.0752Z"
      fill="#FF612B"
    />
    <path
      d="M22.8351 31.4083H12.0022C11.542 31.4083 11.1689 31.0352 11.1689 30.575C11.1689 30.1148 11.542 29.7417 12.0022 29.7417H22.8351C23.4577 29.7417 23.8604 30.3997 23.5772 30.9541C23.4347 31.2328 23.1481 31.4083 22.8351 31.4083Z"
      fill="#002677"
    />
    <path
      d="M22.8351 28.0748H12.0022C11.542 28.0748 11.1689 27.7017 11.1689 27.2415C11.1689 26.7813 11.542 26.4082 12.0022 26.4082H22.8351C23.4577 26.4082 23.8604 27.0662 23.5772 27.6206C23.4347 27.8993 23.1481 28.0748 22.8351 28.0748Z"
      fill="#002677"
    />
    <path
      d="M22.8351 24.7418H12.0022C11.542 24.7418 11.1689 24.3687 11.1689 23.9085C11.1689 23.4483 11.542 23.0752 12.0022 23.0752H22.8351C23.4577 23.0752 23.8604 23.7332 23.5772 24.2876C23.4347 24.5663 23.1481 24.7418 22.8351 24.7418Z"
      fill="#002677"
    />
  </Box>
)

export default CommunicatingStyleNew
